<template>
    <div class="container my-5 py-5 mx-auto">

        <div class="row">
            <div class="col col-lg-8 col-md-10 col-sm-12 offset-lg-2 offset-md-2 offset-sm-0 text-center">
                <div class="card mx-auto my-auto ">

                    <div class="card-header my-auto">
                        <div class="card-title text-left font-weight-bolder text-danger">
                            <span class="fas fa-user-lock"></span>
                            CHANGE PASSWORD
                        </div>
                    </div>


                    <form class="card-body" @submit.prevent="confirmChangePassword">

                        <div class="form-group form-row" :class="{ 'has-error': updatePasswordErrors.password }">
                            <label class="col col-sm-4 col-form-label font-weight-bolder text-right"
                                   for="password">Password:
                            </label>
                            <div class="col col-sm-8">
                                <div class="input-group">
                                    <input :type="showPass ? 'text' : 'password'" id="password"
                                           required placeholder="OLD PASSWORD"
                                           class="form-control"
                                           v-model="password"
                                    >
                                    <div class="input-group-append">
                                        <button class="btn btn-secondary" type="button" title="Show Password" @click="showPass = !showPass">
                                            <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                        </button>
                                    </div> <br />
                                </div>
                                <span class="help-block text-danger" v-if="updatePasswordErrors.password">
                                    <small><strong>{{ updatePasswordErrors.password }} </strong></small>
                                </span>
                            </div>
                        </div>

                        <div class="form-group form-row" :class="{ 'has-error': updatePasswordErrors.newPassword }">
                            <label class="col col-sm-4 col-form-label font-weight-bolder text-right"
                                   for="newPassword">New Password:
                            </label>
                            <div class="col col-sm-8">
                                <div class="input-group">
                                    <input :type="showNew ? 'text' : 'password'" id="newPassword"
                                           required placeholder="NEW PASSWORD"
                                           class="form-control"
                                           v-model="newPassword"
                                    >
                                    <div class="input-group-append">
                                        <button class="btn btn-secondary" type="button" title="Show Password" @click="showNew = !showNew">
                                            <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                                <span class="help-block text-danger" v-if="updatePasswordErrors.newPassword">
                                    <small><strong>{{ updatePasswordErrors.newPassword }} </strong></small>
                                </span>
                            </div>
                        </div>

                        <div class="form-group form-row" :class="{ 'has-error': updatePasswordErrors.confirmNewPassword }">
                            <label class="col col-sm-4 col-form-label font-weight-bolder text-right"
                                   for="confirmNewPassword">Confirm New Password:
                            </label>
                            <div class="col col-sm-8">
                                <div class="input-group">
                                    <input :type="showConfirm ? 'text' : 'password'" id="confirmNewPassword"
                                           required placeholder="CONFIRM NEW PASSWORD"
                                           class="form-control"
                                           v-model="confirmNewPassword"
                                    >
                                    <div class="input-group-append">
                                        <button class="btn btn-secondary" type="button" title="Show Password" @click="showConfirm = !showConfirm">
                                            <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                                <span class="help-block text-danger" v-if="updatePasswordErrors.confirmNewPassword">
                                    <small><strong>{{ updatePasswordErrors.confirmNewPassword }} </strong></small>
                                </span>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-block login-button">
                            Update Password
                        </button>

                    </form>

                </div>
            </div>
        </div> <!-- <div class="row">-->
    </div>  <!-- <div class="container my-5 py-5 test">-->
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";

export default {
    name: "ChangePassword",
    mixins: [ vueAppMixin ],
    data() {
        return {
            password: '',
            newPassword: '',
            confirmNewPassword: '',
            showPass: false,
            showNew: false,
            showConfirm: false,
            updatePasswordErrors: {
                password: '',
                newPassword: '',
                confirmNewPassword: ''
            }
        }
    },

    methods: {
        ...mapActions([ 'updateUserPassword' ]),
        async confirmChangePassword() {
            let errorPassword = this.verifyPasswordErrors();
            if(errorPassword) {
                this.errorAlert(errorPassword, 'UPDATE PASSWORD')
                return false;
            }
            if(await this.confirmUpdate('Are you sure you want to change you password?', 'CHANGE PASSWORD')) {
                let params = {
                    id: this.user.id,
                    password: this.password,
                    newPassword: this.newPassword
                };
                let updatedUserPassword = await this.updateUserPassword(params);
                if(!updatedUserPassword) {
                    this.errorAlert('Failed to Update User Password');
                } else if(updatedUserPassword.errors) {
                    this.updatePasswordErrors = updatedUserPassword.errors;
                } else {
                    this.successAlert('User Password Successfully Updated', 'UPDATE PASSWORD');
                }
            }
        },

        verifyPasswordErrors() {
            this.updatePasswordErrors = {
                password: '',
                newPassword: '',
                confirmNewPassword: ''
            }
            let error = '';
            if(this.newPassword !== this.confirmNewPassword) {
                error = 'PASSWORD NOT MATCHED';
                this.updatePasswordErrors.newPassword = error;
                this.updatePasswordErrors.confirmNewPassword = error;
            } else if(this.password === this.newPassword) {
                error = 'NEW PASSWORD MUST NOT BE SIMILAR TO OLD PASSWORD';
                this.updatePasswordErrors.password = error;
                this.updatePasswordErrors.newPassword = error;
            }
            return error;
        }

    },

    computed: {
        ...mapGetters([ 'user' ])
    }

}
</script>

<style scoped>
.login-button {
    background: #FF0000;
    color: white;
    font-family: 'Segoe UI', Helvetica, sans-serif;
    font-weight: bold;
}
</style>
